import { render, staticRenderFns } from "./EditBadgeTask.vue?vue&type=template&id=656542a6&"
import script from "./EditBadgeTask.vue?vue&type=script&lang=js&"
export * from "./EditBadgeTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports